import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";

import Header from '../../layout/Header'
import Subheader from '../../layout/Subheader'
import { useHistory } from 'react-router'

import useStyles from './style'
import { calcLengthBtnMenu, getURL } from "../../services/auth";

function OperationMenu () {
    const history = useHistory()
    const { menus } = JSON.parse(sessionStorage.getItem('@Capitalle-Menu'));
    const classes = useStyles()
    const [largerItemLenght, setLargerItemLenght] = useState(0);

    useEffect(() => {
        const currentMenus = menus.filter((menu) => menu.controle == 100)
        if(currentMenus.length == 1) {
            sessionStorage.setItem('@Capitalle-Current-Menu', currentMenus[0].menuId)
            history.push('/app/operacao-antecipacao')
        }
        if(menus)
        setLargerItemLenght(0)
    }, [])

    return (
        <div className={classes.root}>
            <Header />
            <Subheader title={"Operações"} />
            <div className={classes.content}>
                <div className={classes.contentHome}>
                    {menus && menus.map((menu) => (
                        <>
                            {menu.controle == 100 && (
                                <Link
                                    to={'/app/operacao-antecipacao'}
                                    className={classes.cardLink}
                                    onClick={() => sessionStorage.setItem('@Capitalle-Current-Menu', menu.menuId)}
                                    style={{ width: calcLengthBtnMenu(menu.titulo, setLargerItemLenght, largerItemLenght), backgroundColor: menu.corFundo }}
                                >
                                    <span className={classes.cardLinkText} style={{ color: menu.corFonte }}>{menu.titulo}</span>
                                </Link>
                            )}
                        </>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default OperationMenu
